import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { CalendarPopoverChildren } from '../UI/Popper/Popper';
import ScreenReaderOnly from '../ScreenReaderOnly/ScreenReaderOnly';
import { classes } from '../Event/Event.st.css';
import '../../../locale/i18next';
import { useTranslation } from 'react-i18next';
import * as moment from 'moment-timezone';
import WeeklyExpandedEvent from '../WeeklyExpandedEvent/WeeklyExpandedEvent';
var EventPopup = function (_a) {
    var _b = _a.isCloseFocused, isCloseFocused = _b === void 0 ? false : _b, eventColor = _a.eventColor, title = _a.title, handleCloseClick = _a.handleCloseClick, timezone = _a.timezone, _c = _a.locale, locale = _c === void 0 ? '' : _c, _d = _a.isWeekly, isWeekly = _d === void 0 ? false : _d, rest = __rest(_a, ["isCloseFocused", "eventColor", "title", "handleCloseClick", "timezone", "locale", "isWeekly"]);
    var i18n = useTranslation().i18n;
    React.useEffect(function () {
        locale && void i18n.changeLanguage(locale);
    }, [locale]);
    moment.locale(locale);
    moment.tz.setDefault(timezone);
    var expandedTitle = (React.createElement("div", { className: classes.ExpandedTitleContainer, style: { borderLeft: "2px solid ".concat(eventColor) } },
        React.createElement(Text, { className: classes.ExpandedTitle }, title)));
    //@ts-ignore
    var firstButton = React.useRef();
    //@ts-ignore
    var lastButton = React.useRef();
    var onFirstReached = function (e) {
        if (e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            lastButton.current.focus();
        }
    };
    var onLastReached = function (e) {
        if (!e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            firstButton.current.focus();
        }
    };
    return (React.createElement("div", null,
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: firstButton, onKeyDown: onFirstReached })),
        React.createElement(CalendarPopoverChildren, { calendarPopoverClass: 'Event', isMobile: true, title: expandedTitle, handleCloseClick: handleCloseClick, isCloseFocused: isCloseFocused },
            React.createElement(WeeklyExpandedEvent, { title: title, expandedEventsProps: __assign({}, rest), isMobile: true, locale: locale })),
        React.createElement(ScreenReaderOnly, null,
            React.createElement("button", { ref: lastButton, onKeyDown: onLastReached }))));
};
export default EventPopup;
//# sourceMappingURL=EventPopup.js.map